import baseAPI from '../services/api-service';

const fetchOrder = async ({ sessionToken, boardId, itemId, templateId }) => {
  if (!sessionToken) return;

  const apiService = baseAPI(sessionToken);

  return apiService.get(`orders/templates/${templateId}/boards/${boardId}/items/${itemId}`);
};

const saveOrder = async ({ sessionToken, orderId, data, orderNumber, orderDate }) => {
  if (!sessionToken) return;

  const apiService = baseAPI(sessionToken);

  return apiService.put(`orders/${orderId}`, { data, orderNumber, orderDate });
};

const fetchLatestOrderLink = async ({ sessionToken, orderId }) => {
  if (!sessionToken) return;

  const apiService = baseAPI(sessionToken);

  return apiService.get(`orders/${orderId}/links/latest`);
};

const functions = {
  fetchOrder,
  saveOrder,
  fetchLatestOrderLink,
};

export default functions;
